import { useCallback } from "react";

import { useIntl } from "react-intl";

import Email from "@mapmycustomers/shared/types/email/Email";

import useIsCurrentUserEmail from "@app/component/EntityEmails/util/useIsCurrentUserEmail";

import messages from "../components/messages";

const useGetEmailSenderName = () => {
  const intl = useIntl();
  const isCurrentUserEmail = useIsCurrentUserEmail();

  return useCallback(
    (email: Email, convertMe: boolean = true) => {
      const sender = email.from[0];

      if (convertMe && isCurrentUserEmail(sender.email)) {
        return intl.formatMessage(messages.meRecipient);
      }

      return (
        sender.name ||
        email.recipientAddress.find((recipient) => recipient.email === sender.email)?.name ||
        sender.email
      );
    },
    [intl, isCurrentUserEmail]
  );
};

export default useGetEmailSenderName;
